import React, { Component } from "react"
import { formatDateTsAlt } from "../util/date_utils"
import { formatStripeDollarAmount } from "../util/billing_info_utils"


const BILLING_OVERVIEW_PAYMENT_DOWNLOAD = "Download"

class PaymentHistoryTableRow extends Component {
    constructor(props) {
        super(props)
    }

    renderPaymentHistoryData = (tableData = []) =>
        tableData.map((item, i) => <p key={i}>{item}</p>)

    render() {
        const { createdAt, paymentMethod, amount, invoiceNumber } = this.props
        return (
            <div className="billing-overview-table-row">
                {this.renderPaymentHistoryData([
                    invoiceNumber,
                    formatDateTsAlt(createdAt),
                    paymentMethod,
                    formatStripeDollarAmount(amount),
                ])}
                <button className="justify-last-item billing-overview-table-btn">
                    {BILLING_OVERVIEW_PAYMENT_DOWNLOAD}
                </button>
            </div>
        )
    }
}

export default PaymentHistoryTableRow



// WEBPACK FOOTER //
// ./src/components/payment_history_table_row.jsx